import { useState } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-navy text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold tracking-tight">Exo Contracting Inc.</Link>
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="focus:outline-none">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>
        <ul className={`md:flex md:space-x-8 ${isOpen ? 'block' : 'hidden'} md:block absolute md:static bg-navy w-full md:w-auto left-0 top-16 md:top-0 transition-all duration-300`}>
          <li className="md:inline-block"><Link to="/" className="block px-4 py-2 hover:text-gold transition-colors">Home</Link></li>
          <li className="md:inline-block"><Link to="/about" className="block px-4 py-2 hover:text-gold transition-colors">About</Link></li>
          <li className="md:inline-block"><Link to="/services" className="block px-4 py-2 hover:text-gold transition-colors">Services</Link></li>
          <li className="md:inline-block"><Link to="/projects" className="block px-4 py-2 hover:text-gold transition-colors">Projects</Link></li>
          <li className="md:inline-block"><Link to="/contact" className="block px-4 py-2 hover:text-gold transition-colors">Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;